<template>
  <span ref="spanRef" class="group inline-flex content-center items-center gap-1.5">
    <component
      :is="icon"
      :class="[colorIconClass, { 'h-5 w-5': size === 'base', 'h-4 w-4': size === 'small' }]"
      class="self-center"
      aria-hidden="true"
    >
    </component>
    <span :class="tooltip && 'underline decoration-dotted group-hover:text-neutral-20'" class="text-sm text-neutral-40">
      {{ title }}
    </span>
  </span>
</template>

<script setup lang="ts">
import { computed, ref, toRef } from "vue";
import type { Component } from "vue";
import { CheckCircleIcon } from "@heroicons/vue/outline";
import { useTooltip } from "@composables/tooltips";

//Types
import { Placement } from "@popperjs/core";
export type ColorsType = "gray" | "lightGray" | "green" | "lightRed" | "red" | "sky" | "yellow" | "black";

const props = withDefaults(
  defineProps<{
    icon: Component;
    title: string;
    color?: ColorsType;
    tooltip?: string;
    tooltipPlacement?: Placement;
    size?: "small" | "base";
  }>(),
  {
    icon: CheckCircleIcon,
    title: "",
    color: "gray",
    tooltip: "",
    tooltipPlacement: "auto",
    size: "base",
  },
);

const spanRef = ref();
const contentToRef = toRef(props, "tooltip");
contentToRef.value && useTooltip(spanRef, contentToRef, { placement: props.tooltipPlacement });

const colorIconClass = computed(() => {
  switch (props.color) {
    case "green":
      return "text-success-60";
    case "yellow":
      return "text-warning-60";
    case "red":
      return "text-danger-60";
    case "lightRed":
      return "text-danger-60";
    case "sky":
      return "text-primary-60";
    case "gray":
      return "text-neutral-60";
    case "lightGray":
      return "text-neutral-60";
    case "black":
      return "text-neutral-0";
    default:
      return "";
  }
});
</script>

<style scoped>
.decoration-dotted {
  text-decoration-style: dotted;
}
</style>
